import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Alumnos',
    name: 'Alumnos',
    component: () => import(/* webpackChunkName: "imagenes" */ '../views/Alumnos.vue')
  },
  {
    path: '/Docentes',
    name: 'Docentes',
    component: () => import(/* webpackChunkName: "imagenes" */ '../views/Docentes.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
